// extracted by mini-css-extract-plugin
export default {"formPageHeader":"styles_formPageHeader__6ZXwY","formPageText":"styles_formPageText__LXbht"};